/**
 * SHOPLINE product suggestions.
 *
 * When a user has a synced SHOPLINE store, the backend builds social post
 * suggestions from the store's products and adds these fields to each item.
 * Pass them through unchanged when generating a post, so the post keeps the
 * product's own image and links back to the original product page.
 */
export interface ShoplineSuggestionFields {
  product_id?: string;
  product_title?: string;
  product_url?: string;
  product_price?: string;
  product_images?: string[];
  source_url?: string;
  content_source?: string;
}

export const isShoplineSuggestion = (item: any): boolean =>
  !!(item && (item.product_id || item.content_source === "shopline"));

export const shoplineFields = (item: any): ShoplineSuggestionFields =>
  isShoplineSuggestion(item)
    ? {
        product_id: item.product_id,
        product_title: item.product_title,
        product_url: item.product_url,
        product_price: item.product_price,
        product_images: item.product_images || [],
        source_url: item.source_url || item.product_url,
        content_source: "shopline",
      }
    : {};
